// Wishlist Page Functionality
(function() {
  'use strict';

  // Feature icons mapping: key -> { label, file }
  const FEATURE_ICONS_MAP = {
    biologisch: { label: 'Biologisch', file: 'Biologisch.svg' },
    eko: { label: 'Eko', file: 'Eko-keurmerk.svg' },
    cosmos_organic: { label: 'Cosmos Organic', file: 'Cosmos.svg' },
    demeter: { label: 'Demeter', file: 'Demeter.svg' },
    msc: { label: 'MSC', file: 'MSC.svg' },
    vegan: { label: 'Vegan', file: 'Vegan.svg' },
    glutenvrij: { label: 'Glutenvrij', file: 'Glutenvrij.svg' },
    lactosevrij: { label: 'Lactosevrij', file: 'Lactosevrij.svg' },
    suikervrij: { label: 'Suikervrij', file: 'Suikervrij.svg' },
    zoutarm: { label: 'Zoutarm', file: 'Zoutarm.svg' },
    gistvrij: { label: 'Gistvrij', file: 'Gistvrij.svg' },
    alcoholvrij: { label: 'Alcoholvrij', file: 'Alcoholvrij.svg' },
    raw: { label: 'Raw', file: 'Raw.svg' },
    spf_50_plus: { label: 'SPF 50+', file: 'SPF_50_plus.svg' },
    spf_60: { label: 'SPF 60', file: 'SPF 60.svg' },
    spf_50: { label: 'SPF 50', file: 'SPF 50.svg' },
    spf_30_plus: { label: 'SPF 30+', file: 'SPF_30_plus.svg' },
    spf_30: { label: 'SPF 30', file: 'SPF 30.svg' },
    spf_25: { label: 'SPF 25', file: 'SPF 25.svg' },
    spf_20: { label: 'SPF 20', file: 'SPF 20.svg' },
    spf_15_plus: { label: 'SPF 15+', file: 'SPF_15_plus.svg' },
    spf_15: { label: 'SPF 15', file: 'SPF 15.svg' },
    spf_10: { label: 'SPF 10', file: 'SPF 10.svg' },
    parfumvrij: { label: 'Parfumvrij', file: 'Parfumvrij.svg' },
    microplasticvrij: { label: 'Microplasticvrij', file: 'Microplasticvrij.svg' }
  };

  class WishlistPage {
    constructor() {
      this.container = document.getElementById('wishlist-products');
      this.emptyState = document.getElementById('wishlist-empty');
      this.countText = document.getElementById('wishlist-count-text');
      this.addAllButton = document.getElementById('add-all-to-cart');
      this.shareButton = document.getElementById('share-wishlist');
      this.shareModal = document.getElementById('share-modal');
      this.shareUrlInput = document.getElementById('share-url-input');
      this.copyLinkButton = document.getElementById('copy-share-link');
      this.loginBanner = document.getElementById('login-to-save-banner');
      
      if (!this.container) {
        return;
      }
      
      this.init();
      this.attachEventListeners();
    }

    init() {
      if (!window.WishlistManager) {
        setTimeout(() => this.init(), 100);
        return;
      }
      
      this.loadSharedWishlist();
      this.loadProducts();
    }
    
    loadSharedWishlist() {
      const urlParams = new URLSearchParams(window.location.search);
      const sharedData = urlParams.get('shared');
      
      if (sharedData) {
        try {
          const items = decodeURIComponent(sharedData).split(',').map(item => {
            const parts = item.split(':');
            return {
              handle: parts[0],
              variantId: parts[1] ? parseInt(parts[1]) : null
            };
          });
          
          this.sharedWishlist = items;
          this.isViewingShared = true;
          this.showSharedNotification();
        } catch (e) {
          // Error loading shared wishlist
        }
      }
    }
    
    showSharedNotification() {
      const notification = document.createElement('div');
      notification.className = 'wishlist-shared-notification';
      notification.innerHTML = `
        <p>Je bekijkt een gedeelde wishlist</p>
        <button class="wishlist-import-button btn btn--secondary btn--small">
          Importeer naar mijn wishlist
        </button>
      `;
      
      const header = document.querySelector('.wishlist-page__header');
      if (header) {
        header.appendChild(notification);
        
        const importButton = notification.querySelector('.wishlist-import-button');
        if (importButton) {
          importButton.addEventListener('click', () => this.importSharedWishlist());
        }
      }
    }
    
    importSharedWishlist() {
      if (!this.sharedWishlist) return;
      
      this.sharedWishlist.forEach(item => {
        window.WishlistManager.addItem(item.handle, item.variantId);
      });
      
      const url = new URL(window.location);
      url.searchParams.delete('shared');
      window.history.replaceState({}, '', url);
      
      this.isViewingShared = false;
      this.sharedWishlist = null;
      
      this.loadProducts();
      
      const notification = document.querySelector('.wishlist-shared-notification');
      if (notification) notification.remove();
      
      alert('Wishlist geïmporteerd!');
    }

    attachEventListeners() {
      document.addEventListener('wishlist:updated', () => {
        this.loadProducts();
      });
      
      document.addEventListener('cart:updated', async () => {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          this.updateQuantityLimits(cart);
        } catch (error) {
          // Error refreshing quantity limits
        }
      });
      
      document.addEventListener('cart:refresh', async () => {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          this.updateQuantityLimits(cart);
        } catch (error) {
          // Error refreshing quantity limits
        }
      });
      
      if (this.addAllButton) {
        this.addAllButton.addEventListener('click', (e) => this.handleAddAllToCart(e));
      }
      
      if (this.loginBanner) {
        const closeButton = this.loginBanner.querySelector('.wishlist-login-banner__close');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            this.loginBanner.style.display = 'none';
            localStorage.setItem('wishlist_login_banner_dismissed', 'true');
          });
        }
      }
      
      if (this.shareButton) {
        this.shareButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.openShareModal();
        });
      }
      
      if (this.shareModal) {
        const closeButton = this.shareModal.querySelector('.wishlist-share-modal__close');
        const overlay = this.shareModal.querySelector('.wishlist-share-modal__overlay');
        
        if (closeButton) {
          closeButton.addEventListener('click', () => this.closeShareModal());
        }
        
        if (overlay) {
          overlay.addEventListener('click', () => this.closeShareModal());
        }
      }
      
      if (this.copyLinkButton) {
        this.copyLinkButton.addEventListener('click', () => this.copyShareLink());
      }
      
      if (this.shareModal) {
        this.shareModal.querySelectorAll('.wishlist-share-platform').forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.shareViaPlatform(button.dataset.platform);
          });
        });
      }
    }

    async loadProducts() {
      if (!window.WishlistManager) {
        return;
      }

      const wishlist = this.isViewingShared ? this.sharedWishlist : window.WishlistManager.getWishlist();
      
      if (wishlist.length === 0) {
        this.showEmptyState();
        return;
      }

      this.hideEmptyState();
      this.updateCount(wishlist.length);
      
      try {
        const handles = wishlist.map(item => item.handle);
        const products = await this.fetchProducts(handles);
        
        products.forEach(product => {
          const wishlistItem = wishlist.find(item => item.handle === product.handle);
          if (wishlistItem) {
            product.wishlistVariantId = wishlistItem.variantId;
          }
        });
        
        if (products.length === 0) {
          this.showEmptyState();
          return;
        }
        
        this.renderProducts(products);
        this.showAddAllButton();
        this.showShareButton();
        this.showLoginBannerIfNeeded();
      } catch (error) {
        // Error loading wishlist products
      }
    }

    async fetchProducts(handles) {
      const promises = handles.map(async handle => {
        try {
          const jsonUrl = `/products/${handle}.js`;
          const jsonResponse = await fetch(jsonUrl);
          
          if (!jsonResponse.ok) throw new Error(`HTTP ${jsonResponse.status}`);
          
          const product = await jsonResponse.json();
          
          try {
            const pageUrl = `/products/${handle}`;
            const pageResponse = await fetch(pageUrl);
            if (pageResponse.ok) {
              const pageHtml = await pageResponse.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(pageHtml, 'text/html');
              
              const productInfo = doc.querySelector('product-info[data-quantity-limited="true"]');
              const maxQuantity = productInfo ? parseInt(productInfo.dataset.maxQuantity) || 5 : 5;
              
              // Check for UAD metafield (hide compare-at price)
              const uadElement = doc.querySelector('[data-uad="true"]');
              const hasUad = uadElement !== null;
              
              // Also check if the price section has no compare price visible (alternative detection)
              const priceSection = doc.querySelector('.f-price');
              const hasOnSaleClass = priceSection && priceSection.classList.contains('f-price--on-sale');
              
              if (productInfo) {
                product.metafields = {
                  custom: {
                    maximaal_5_stuks_bestellen: true,
                    max_quantity: maxQuantity,
                    uad: hasUad
                  }
                };
              } else {
                product.metafields = {
                  custom: {
                    maximaal_5_stuks_bestellen: false,
                    max_quantity: 5,
                    uad: hasUad
                  }
                };
              }
              
              // Extract feature icons from product page
              const featureIconsEl = doc.querySelector('.pcard-feature-icons');
              if (featureIconsEl) {
                product.featureIconsHtml = featureIconsEl.outerHTML;
              }
              
              // If no icons found, try fetching the icons-only view
              if (!product.featureIconsHtml) {
                try {
                  const iconsUrl = `/products/${handle}?view=icons`;
                  const iconsResponse = await fetch(iconsUrl);
                  if (iconsResponse.ok) {
                    const iconsHtml = await iconsResponse.text();
                    const iconsDoc = new DOMParser().parseFromString(iconsHtml, 'text/html');
                    const icons = iconsDoc.querySelector('.pcard-feature-icons');
                    if (icons) {
                      product.featureIconsHtml = icons.outerHTML;
                    }
                  }
                } catch (iconsErr) {
                  // Icons view fetch failed
                }
              }
            }
          } catch (metaErr) {
            product.metafields = {
              custom: {
                maximaal_5_stuks_bestellen: false,
                uad: false
              }
            };
          }
          
          return product;
        } catch (err) {
          return null;
        }
      });
      
      const products = await Promise.all(promises);
      const validProducts = products.filter(p => p !== null);
      
      return validProducts;
    }
    
    // convertFeaturesToPcardIcons method removed - icons only shown on product page

    async renderProducts(products) {
      if (!this.container) {
        return;
      }
      
      let cart = null;
      try {
        const cartResponse = await fetch('/cart.js');
        cart = await cartResponse.json();
      } catch (error) {
        // Error fetching cart
      }
      
      const html = products.map(product => this.createProductCard(product, cart)).join('');
      
      this.container.innerHTML = html;
      
      if (window.WishlistManager) {
        setTimeout(() => {
          window.WishlistManager.updateAllButtons();
        }, 100);
      }
      
      if (window.jdgm && typeof window.jdgm.customInitWidgets === 'function') {
        setTimeout(() => {
          window.jdgm.customInitWidgets();
        }, 500);
      }
      
      this.updateQuantityLimits(cart);
      this.attachProductEventListeners();
    }
    
    attachProductEventListeners() {
      this.container.querySelectorAll('.quantity__button').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const quantitySelector = btn.closest('quantity-selector');
          const input = quantitySelector.querySelector('.quantity__input');
          const currentValue = parseInt(input.value) || 1;
          const maxValue = parseInt(input.getAttribute('max')) || 99;
          const minValue = parseInt(input.getAttribute('min')) || 1;
          
          let newValue = currentValue;
          
          if (btn.name === 'plus') {
            if (currentValue < maxValue) {
              newValue = currentValue + 1;
              input.value = newValue;
            }
          } else if (btn.name === 'minus') {
            if (currentValue > minValue) {
              newValue = currentValue - 1;
              input.value = newValue;
            }
          }
          
          if (newValue !== currentValue) {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          this.updateQuantityButtonStates(quantitySelector);
        });
      });
      
      this.container.querySelectorAll('.wishlist-variant-select').forEach(select => {
        select.addEventListener('change', (e) => this.handleVariantChange(e));
      });
      
      this.container.querySelectorAll('.wishlist-atc-button').forEach(btn => {
        btn.addEventListener('click', (e) => this.handleAddToCart(e));
      });
      
      this.container.querySelectorAll('[data-tooltip-trigger]').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const tooltip = trigger.nextElementSibling;
          if (tooltip && tooltip.classList.contains('price-tooltip')) {
            const isHidden = tooltip.getAttribute('aria-hidden') === 'true';
            tooltip.setAttribute('aria-hidden', !isHidden);
          }
        });
      });
    }
    
    handleVariantChange(e) {
      const select = e.currentTarget;
      const selectedOption = select.options[select.selectedIndex];
      const variantId = selectedOption.value;
      const price = parseInt(selectedOption.dataset.price);
      const comparePrice = parseInt(selectedOption.dataset.comparePrice);
      
      const card = select.closest('.product-card');
      const priceContainer = card.querySelector('[data-price-container]');
      const atcButton = card.querySelector('.wishlist-atc-button');
      const vendorEl = card.querySelector('.product-card__vendor a');
      const vendorName = vendorEl ? vendorEl.textContent.trim() : 'de fabrikant';
      
      // Check if UAD is enabled (no compare price should be shown)
      const isUadEnabled = card.dataset.uadEnabled === 'true';
      const showComparePrice = !isUadEnabled && comparePrice > price;
      
      let priceHtml = '';
      if (showComparePrice) {
        priceHtml = `
          <span class="price__compare">${this.formatMoney(comparePrice)}</span>
          <span style="font-size: 1.2rem; color: #999;">(adviesprijs)</span>
          <span class="price__regular">${this.formatMoney(price)}</span>
          <div class="price-tooltip-wrapper">
            <button type="button" class="price-tooltip-trigger" data-tooltip-trigger>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7.5" stroke="currentColor"/>
                <text x="8" y="11" text-anchor="middle" font-size="10" fill="currentColor" font-weight="bold">i</text>
              </svg>
            </button>
            <div class="price-tooltip" role="tooltip" aria-hidden="true">
              Adviesprijs van ${this.escapeHtml(vendorName)}.
              <a href="/pages/adviesprijzen-en-kortingscodes" class="price-tooltip-link">Klik hier voor meer informatie.</a>
            </div>
          </div>
        `;
      } else {
        priceHtml = `<span class="price__regular">${this.formatMoney(price)}</span>`;
      }
      priceContainer.innerHTML = priceHtml;
      
      if (atcButton) {
        atcButton.dataset.variantId = variantId;
      }
    }
    
    async handleAddToCart(e) {
      e.preventDefault();
      
      const btn = e.currentTarget;
      const card = btn.closest('.product-card');
      
      let variantId = btn.dataset.variantId;
      const variantSelect = card.querySelector('.wishlist-variant-select');
      if (variantSelect) {
        variantId = variantSelect.value;
      }
      
      const wrapper = btn.closest('.wishlist-atc-wrapper');
      const input = wrapper.querySelector('.quantity__input');
      const quantity = parseInt(input.value) || 1;
      
      if (!variantId) {
        alert('Selecteer eerst een variant');
        return;
      }
      
      const isLimited = card.dataset.quantityLimited === 'true';
      const productId = card.dataset.productId;
      const maxQuantity = parseInt(card.dataset.maxQuantity) || 5;
      
      if (isLimited && productId) {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          const currentQty = cart.items
            .filter(item => item.product_id.toString() === productId)
            .reduce((sum, item) => sum + item.quantity, 0);
          
          if (currentQty >= maxQuantity) {
            alert(`Je hebt al het maximale aantal (${maxQuantity}) van dit product in je winkelwagen.`);
            return;
          }
          
          if (currentQty + quantity > maxQuantity) {
            const remaining = maxQuantity - currentQty;
            alert(`Je kunt nog maar ${remaining} stuks toevoegen. Maximum is ${maxQuantity} per klant.`);
            return;
          }
        } catch (error) {
          // Error checking quantity limit
        }
      }
      
      btn.disabled = true;
      btn.classList.add('btn--loading');
      
      try {
        const formData = {
          items: [{
            id: parseInt(variantId),
            quantity: quantity
          }]
        };
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });
        
        const result = await response.json();
        
        if (result.status && result.status !== 200) {
          throw new Error(result.description || result.message || 'Failed to add to cart');
        }
        
        try {
          if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
          }
        } catch (pubsubError) {
          // Pubsub update failed
        }
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }
        
        this.showAddToCartSuccess(btn);
        input.value = 1;
        
      } catch (error) {
        alert(`Er ging iets mis: ${error.message}`);
      } finally {
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      }
    }
    
    showAddToCartSuccess(btn) {
      const originalText = btn.querySelector('.btn__text').textContent;
      btn.querySelector('.btn__text').textContent = '✓ Toegevoegd';
      btn.classList.add('btn--success');
      
      setTimeout(() => {
        btn.querySelector('.btn__text').textContent = originalText;
        btn.classList.remove('btn--success');
      }, 2000);
    }

    createProductCard(product, cart = null) {
      let selectedVariant = product.variants[0];
      if (product.wishlistVariantId) {
        const savedVariant = product.variants.find(v => v.id == product.wishlistVariantId);
        if (savedVariant) {
          selectedVariant = savedVariant;
        }
      }
      
      const variant = selectedVariant;
      const price = this.formatMoney(variant.price);
      
      // Check UAD metafield - if true, hide compare-at price (van-prijs)
      const isUadEnabled = product.metafields?.custom?.uad === true;
      const comparePrice = !isUadEnabled && variant.compare_at_price > variant.price 
        ? this.formatMoney(variant.compare_at_price)
        : '';
      
      const imageUrl = product.featured_image || product.images[0] || '';
      const hasMultipleVariants = product.variants.length > 1;
      const hasAvailableVariant = product.variants.some(v => v.available);

      const variantSelectorHtml = hasMultipleVariants ? `
        <div class="wishlist-variant-selector">
          <select class="wishlist-variant-select" data-product-id="${product.id}">
            ${product.variants.map(v => `
              <option 
                value="${v.id}" 
                ${!v.available ? 'disabled' : ''}
                ${v.id == variant.id ? 'selected' : ''}
                data-price="${v.price}"
                data-compare-price="${v.compare_at_price || 0}"
              >
                ${this.escapeHtml(v.title)}${!v.available ? ' - Uitverkocht' : ''}
              </option>
            `).join('')}
          </select>
        </div>
      ` : '';

      const isQuantityLimited = product.metafields?.custom?.maximaal_5_stuks_bestellen === true;
      const productMaxQuantity = product.metafields?.custom?.max_quantity || 5;
      
      let maxQuantity = 99;
      let cartQuantity = 0;
      if (isQuantityLimited && cart && cart.items) {
        cartQuantity = cart.items
          .filter(item => item.product_id === product.id)
          .reduce((sum, item) => sum + item.quantity, 0);
        maxQuantity = Math.max(1, productMaxQuantity - cartQuantity);
      } else if (isQuantityLimited) {
        maxQuantity = productMaxQuantity;
      }
      
      return `
        <div class="product-card" data-product-handle="${product.handle}" data-product-id="${product.id}" ${isQuantityLimited ? `data-quantity-limited="true" data-max-quantity="${productMaxQuantity}"` : ''} ${isUadEnabled ? 'data-uad-enabled="true"' : ''}>
          <div class="product-card__wrapper">
            <div class="product-card__image-wrapper">
              <wishlist-button data-product-handle="${product.handle}"></wishlist-button>
              ${product.featureIconsHtml || this.generateFeatureIconsHtml(product.featureIconKeys) || ''}
              <a href="/products/${product.handle}">
                ${imageUrl 
                  ? `<img 
                      src="${imageUrl}" 
                      alt="${this.escapeHtml(product.title)}"
                      loading="lazy"
                      class="product-card__image"
                    />`
                  : '<div class="product-card__image placeholder"></div>'
                }
              </a>
            </div>
            <div class="product-card__info">
              ${product.vendor ? `<p class="product-card__vendor"><a href="/collections/${this.escapeHtml(product.vendor.toLowerCase().replace(/\s+/g, '-'))}">${this.escapeHtml(product.vendor)}</a></p>` : ''}
              <h3 class="product-card__title">
                <a href="/products/${product.handle}">
                  ${this.escapeHtml(product.title)}
                </a>
              </h3>
              <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}"></div>
              <div class="product-card__price" data-price-container>
                ${comparePrice ? `
                  <span class="price__compare">${comparePrice}</span>
                  <span style="font-size: 1.2rem; color: #999;">(adviesprijs)</span>
                ` : ''}
                <span class="price__regular">${price}</span>
                ${comparePrice ? `
                  <div class="price-tooltip-wrapper">
                    <button type="button" class="price-tooltip-trigger" data-tooltip-trigger>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7.5" stroke="currentColor"/>
                        <text x="8" y="11" text-anchor="middle" font-size="10" fill="currentColor" font-weight="bold">i</text>
                      </svg>
                    </button>
                    <div class="price-tooltip" role="tooltip" aria-hidden="true">
                      Adviesprijs van ${this.escapeHtml(product.vendor || 'de fabrikant')}.
                      <a href="/pages/adviesprijzen-en-kortingscodes" class="price-tooltip-link">Klik hier voor meer informatie.</a>
                    </div>
                  </div>
                ` : ''}
              </div>
              ${hasAvailableVariant ? `
                ${variantSelectorHtml}
                <div class="wishlist-atc-wrapper">
                  <quantity-selector class="quantity">
                    <button class="quantity__button" name="minus" type="button">
                      <span class="visually-hidden">Verlaag hoeveelheid</span>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                      </svg>
                    </button>
                    <input
                      class="quantity__input"
                      type="number"
                      name="quantity"
                      value="1"
                      min="1"
                      max="${maxQuantity > 0 ? maxQuantity : 1}"
                      step="1"
                      is="quantity-input"
                    >
                    <button class="quantity__button" name="plus" type="button">
                      <span class="visually-hidden">Verhoog hoeveelheid</span>
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                      </svg>
                    </button>
                  </quantity-selector>
                  <button class="wishlist-atc-button btn btn--secondary" data-variant-id="${variant.id}">
                    <span class="btn__text">In winkelwagen</span>
                  </button>
                </div>
              ` : `
                <a href="/products/${product.handle}" class="wishlist-view-button">
                  Uitverkocht
                </a>
              `}
            </div>
          </div>
        </div>
      `;
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return `€${amount.replace('.', ',')}`;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    generateFeatureIconsHtml(keys) {
      if (!keys || keys.length === 0) return '';
      
      const maxIcons = 5;
      const iconsToShow = keys.slice(0, maxIcons);
      
      const iconsHtml = iconsToShow.map(key => {
        const icon = FEATURE_ICONS_MAP[key];
        if (!icon) return '';
        
        // Get the CDN URL for the asset
        // Asset base comes from js-variables.liquid (asset_url), never a hardcoded theme version
        const assetBase = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.asset_base_url) || '';
        const assetUrl = assetBase
          ? `${assetBase}${encodeURIComponent(icon.file)}`
          : `/cdn/shop/files/${encodeURIComponent(icon.file)}`;
        
        return `
          <div class="pcard-feature-icons__item">
            <img src="${assetUrl}" alt="${icon.label}" width="24" height="24" loading="lazy" decoding="async">
            <span class="pcard-feature-icons__tooltip">${icon.label}<span class="pcard-feature-icons__tooltip-arrow"></span></span>
          </div>
        `;
      }).join('');
      
      if (!iconsHtml) return '';
      
      return `<div class="pcard-feature-icons" aria-label="Productkenmerken">${iconsHtml}</div>`;
    }
    
    updateQuantityLimits(cart) {
      if (!cart || !cart.items) return;
      
      this.container.querySelectorAll('.product-card[data-quantity-limited="true"]').forEach(card => {
        const productId = parseInt(card.dataset.productId);
        const maxQuantity = parseInt(card.dataset.maxQuantity) || 5;
        const cartQty = cart.items
          .filter(item => item.product_id === productId)
          .reduce((sum, item) => sum + item.quantity, 0);
        
        const remaining = maxQuantity - cartQty;
        const quantitySelector = card.querySelector('quantity-selector');
        const atcWrapper = card.querySelector('.wishlist-atc-wrapper');
        const atcButton = card.querySelector('.wishlist-atc-button');
        
        if (cartQty >= maxQuantity) {
          if (atcWrapper) {
            atcWrapper.style.display = 'none';
          }
          
          let message = card.querySelector('.quantity-limit-reached-message');
          if (!message) {
            message = document.createElement('div');
            message.className = 'quantity-limit-reached-message alert alert--info blocks-radius-md text-sm';
            message.style.marginTop = '12px';
            message.innerHTML = `Je hebt al het maximale aantal (${maxQuantity}) in je winkelwagen`;
            
            const priceContainer = card.querySelector('.product-card__price');
            if (priceContainer && priceContainer.parentNode) {
              priceContainer.parentNode.insertBefore(message, priceContainer.nextSibling);
            }
          }
        } else {
          if (atcWrapper) {
            atcWrapper.style.display = '';
          }
          
          if (quantitySelector) {
            const input = quantitySelector.querySelector('.quantity__input');
            if (input) {
              input.max = remaining;
              input.setAttribute('max', remaining);
              const currentValue = parseInt(input.value) || 1;
              if (currentValue > remaining) {
                input.value = remaining;
              }
            }
            
            this.updateQuantityButtonStates(quantitySelector);
            
            if (input) {
              const updateHandler = () => this.updateQuantityButtonStates(quantitySelector);
              input.removeEventListener('input', updateHandler);
              input.removeEventListener('change', updateHandler);
              input.addEventListener('input', updateHandler);
              input.addEventListener('change', updateHandler);
            }
          }
          
          if (atcButton) {
            atcButton.disabled = false;
          }
          
          const message = card.querySelector('.quantity-limit-reached-message');
          if (message) {
            message.remove();
          }
        }
      });
    }
    
    updateQuantityButtonStates(quantitySelector) {
      if (!quantitySelector) return;
      
      const input = quantitySelector.querySelector('.quantity__input');
      const plusButton = quantitySelector.querySelector('button[name="plus"]');
      const minusButton = quantitySelector.querySelector('button[name="minus"]');
      
      if (!input) return;
      
      const currentValue = parseInt(input.value) || 1;
      const maxValue = input.max ? parseInt(input.max) : null;
      const minValue = input.min ? parseInt(input.min) : 1;
      
      if (maxValue && currentValue > maxValue) {
        input.value = maxValue;
      }
      
      if (plusButton) {
        const shouldDisable = maxValue && currentValue >= maxValue;
        plusButton.disabled = shouldDisable;
        plusButton.toggleAttribute('disabled', shouldDisable);
      }
      
      if (minusButton) {
        const shouldDisable = currentValue <= minValue;
        minusButton.disabled = shouldDisable;
        minusButton.toggleAttribute('disabled', shouldDisable);
      }
    }

    updateCount(count) {
      if (this.countText) {
        const text = count === 1 ? '1 product' : `${count} producten`;
        this.countText.textContent = text;
      }
    }

    async handleAddAllToCart(e) {
      e.preventDefault();
      
      if (!this.addAllButton) return;
      
      const productCards = this.container.querySelectorAll('.product-card');
      const items = [];
      
      productCards.forEach(card => {
        const variantSelect = card.querySelector('.wishlist-variant-select');
        const atcButton = card.querySelector('.wishlist-atc-button');
        
        if (atcButton && !atcButton.disabled) {
          let variantId;
          
          if (variantSelect) {
            variantId = parseInt(variantSelect.value);
          } else {
            variantId = parseInt(atcButton.dataset.variantId);
          }
          
          if (variantId) {
            items.push({
              id: variantId,
              quantity: 1
            });
          }
        }
      });
      
      if (items.length === 0) {
        alert('Geen beschikbare producten om toe te voegen');
        return;
      }
      
      const originalText = this.addAllButton.textContent;
      this.addAllButton.classList.add('loading');
      this.addAllButton.textContent = 'Bezig met toevoegen...';
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items })
        });
        
        const result = await response.json();
        
        if (result.status && result.status !== 200) {
          throw new Error(result.description || result.message || 'Failed to add to cart');
        }
        
        try {
          if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
          }
        } catch (pubsubError) {
          // Pubsub update failed
        }
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }
        
        this.addAllButton.textContent = `✓ ${items.length} producten toegevoegd!`;
        
        setTimeout(() => {
          this.addAllButton.textContent = originalText;
          this.addAllButton.classList.remove('loading');
        }, 3000);
        
      } catch (error) {
        alert(`Er ging iets mis: ${error.message}`);
        this.addAllButton.textContent = originalText;
        this.addAllButton.classList.remove('loading');
      }
    }
    
    openShareModal() {
      if (!window.WishlistManager || !this.shareModal) return;
      
      const wishlist = window.WishlistManager.getWishlist();
      
      if (wishlist.length === 0) {
        alert('Je wishlist is leeg');
        return;
      }
      
      const wishlistData = wishlist.map(item => `${item.handle}${item.variantId ? ':' + item.variantId : ''}`).join(',');
      this.currentShareUrl = `${window.location.origin}/pages/wishlist?shared=${encodeURIComponent(wishlistData)}`;
      
      if (this.shareUrlInput) {
        this.shareUrlInput.value = this.currentShareUrl;
      }
      
      this.shareModal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    
    closeShareModal() {
      if (this.shareModal) {
        this.shareModal.hidden = true;
        document.body.style.overflow = '';
      }
    }
    
    copyShareLink() {
      if (!this.shareUrlInput || !this.copyLinkButton) return;
      
      this.shareUrlInput.select();
      this.shareUrlInput.setSelectionRange(0, 99999);
      
      navigator.clipboard.writeText(this.currentShareUrl).then(() => {
        if (!this.copyLinkButton) return;
        
        const btnText = this.copyLinkButton.querySelector('.btn__text');
        if (!btnText) return;
        
        const originalText = btnText.textContent;
        btnText.textContent = '✓ Gekopieerd!';
        
        setTimeout(() => {
          if (btnText) {
            btnText.textContent = originalText;
          }
        }, 2000);
      }).catch(err => {
        alert('Kon link niet kopiëren. Selecteer en kopieer handmatig.');
      });
    }
    
    shareViaPlatform(platform) {
      if (!this.currentShareUrl) return;
      
      const text = 'Bekijk mijn wishlist!';
      let shareUrl;
      
      switch(platform) {
        case 'whatsapp':
          shareUrl = `https://wa.me/?text=${encodeURIComponent(text + ' ' + this.currentShareUrl)}`;
          break;
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentShareUrl)}`;
          break;
        case 'instagram':
          this.copyShareLink();
          alert('Link gekopieerd! Plak deze in je Instagram Story of DM');
          this.closeShareModal();
          return;
        case 'email':
          shareUrl = `mailto:?subject=${encodeURIComponent('Mijn wishlist')}&body=${encodeURIComponent(text + '\n\n' + this.currentShareUrl)}`;
          break;
      }
      
      if (shareUrl) {
        window.open(shareUrl, '_blank', 'noopener,noreferrer');
      }
    }
    
    showAddAllButton() {
      if (this.addAllButton) {
        this.addAllButton.style.display = 'inline-flex';
      }
    }
    
    hideAddAllButton() {
      if (this.addAllButton) {
        this.addAllButton.style.display = 'none';
      }
    }
    
    showShareButton() {
      if (this.shareButton) {
        this.shareButton.style.display = 'inline-flex';
      }
    }
    
    hideShareButton() {
      if (this.shareButton) {
        this.shareButton.style.display = 'none';
      }
    }
    
    showLoginBannerIfNeeded() {
      const isLoggedIn = window.WishlistManager && window.WishlistManager.isLoggedIn();
      const wasDismissed = localStorage.getItem('wishlist_login_banner_dismissed') === 'true';
      
      if (!isLoggedIn && !wasDismissed && this.loginBanner) {
        this.loginBanner.style.display = 'flex';
      }
    }

    showEmptyState() {
      if (this.container) {
        this.container.innerHTML = '';
        this.container.style.display = 'none';
      }
      if (this.emptyState) {
        this.emptyState.hidden = false;
        this.emptyState.style.display = 'block';
      }
      this.hideAddAllButton();
      this.hideShareButton();
      this.updateCount(0);
    }

    hideEmptyState() {
      if (this.container) {
        this.container.style.display = 'grid';
      }
      if (this.emptyState) {
        this.emptyState.hidden = true;
        this.emptyState.style.display = 'none';
      }
    }
  }

  function initWishlistPage() {
    if (document.getElementById('wishlist-products')) {
      new WishlistPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }
})();